import { CustomModal } from "components";
import { SpendDebitCardPlus } from "graphql/generated";
import { getBadgeColor } from "helpers/status-color";
import { useAppContext } from "hooks/use-context";
import { useEffect, useState } from "react";
import { SnapBadge, SnapButton, SnapDropDown, SnapTable } from "suit";
import {
  ACTIVE,
  activeCardActions,
  FROZEN,
  frozenCardActions,
  INACTIVE,
  inactiveActions,
} from "./card-data";
import useModal from "hooks/use-modal";
import OrderDebitCard from "./order-debit-card";

type DebitCardsProps = {
  isOpen: boolean;
  toggle: () => void;
  isAddDebitCardsEnabled: boolean;
  cards: SpendDebitCardPlus[];
  refetchCards: any;
};

function DebitCards({
  isOpen,
  toggle,
  isAddDebitCardsEnabled,
  cards,
  refetchCards,
}: DebitCardsProps) {
  const { screenSize } = useAppContext();
  const { isOpen: isOrderDebitCardOpen, toggle: toggleOrderDebitCard } =
    useModal();
  const [activeCard, setActiveCard] = useState<string>();
  const [actionToDispatch, setActionToDispatch] = useState<string>();

  useEffect(() => {
    if (!cards.length) {
      toggleOrderDebitCard();
    }
  }, [cards]);

  const determineActions = (status: string) => {
    if (status === ACTIVE) {
      return activeCardActions;
    } else if (status === INACTIVE) {
      return inactiveActions;
    } else if (status === FROZEN) {
      return frozenCardActions;
    } else {
      return undefined;
    }
  };

  const getCardStatus = (cardStatus: string) => {
    let status = cardStatus;
    if (status === "ClosedByCustomer") {
      return "Closed";
    } else {
      return status.replace(/([A-Z])/g, " $1").trim();
    }
  };

  const handleModalData = (card: SpendDebitCardPlus, action: string) => {
    if (!card.id) {
      return;
    }
    setActiveCard(card.id);
    setActionToDispatch(action);
  };

  return (
    <CustomModal
      title={"Debit Cards"}
      isOpen={isOpen}
      toggle={toggle}
      customStyle="min-h-96"
    >
      <div className="modal-card">
        <div className="hidden">
          {/* <UnitComponentGenerator
            type="card"
            data={{
              cardId: activeCard,
            }}
            permRequired={[SpendPermissions.groupDebitCardUpdate]}
          /> */}
        </div>
        {isOrderDebitCardOpen && (
          <OrderDebitCard
            isOrderDebitCardOpen={isOrderDebitCardOpen}
            toggleOrderDebitCards={toggleOrderDebitCard}
            toggleDebitCardModal={toggle}
            refetchCards={refetchCards}
            cards={cards}
          />
        )}
        {screenSize?.isDesktop && !isOrderDebitCardOpen && (
          <>
            <SnapTable className="flex h-96 overflow-x-scroll">
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Org/Group Name</th>
                    <th>Last 4</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {cards.map((card) => {
                    const options = determineActions(card.status ?? "");
                    const status = getCardStatus(card.status!);
                    return (
                      <tr key={card.id}>
                        <td className="py-2">{card.userName}</td>
                        <td>{card.groupOrOrgName}</td>
                        <td>{card.lastFour}</td>
                        <td>
                          <SnapBadge
                            size="tiny"
                            color={getBadgeColor(card.status ?? "")}
                          >
                            {status}
                          </SnapBadge>
                        </td>
                        <td>
                          {options && (
                            <SnapDropDown
                              minimal
                              options={options}
                              description={`${card.expiration}`}
                              title="Expiration"
                              onSnap-dropdown-item-selected={(e) => {
                                //call function to check token logic here
                                handleModalData(card, e.detail.value);
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </SnapTable>
            {isAddDebitCardsEnabled && (
              <div className="flex justify-end mt-5">
                <SnapButton variant="primary" onClick={toggleOrderDebitCard}>
                  Add Debit Card
                </SnapButton>
              </div>
            )}
          </>
        )}
      </div>
    </CustomModal>
  );
}

export default DebitCards;
